import { cn } from '@1trading/react';

import { useIconStyle } from '@/hooks/use-icon-style';

type AppTileProps = {
  abbr: string;
  color: string;
  icon?: string;
  label: string;
  size?: 'sm' | 'md';
};

/** App icon when the catalog ships one and icons are preferred; otherwise branded initials. */
export const AppTile = ({ abbr, color, icon, label, size = 'md' }: AppTileProps) => {
  const { iconStyle } = useIconStyle();
  const box = cn('flex shrink-0 items-center justify-center overflow-hidden', size === 'md' ? 'size-10 rounded-[10px]' : 'size-6 rounded-md');

  if (icon && iconStyle === 'image') {
    return (
      <span aria-hidden className={cn(box, 'border border-border/60 bg-white dark:bg-white')}>
        <img src={icon} alt="" className={cn('object-contain', size === 'md' ? 'size-6' : 'size-3.5')} loading="lazy" />
      </span>
    );
  }

  return (
    <span aria-hidden title={label} style={{ backgroundColor: color }} className={cn(box, 'font-semibold text-white', size === 'md' ? 'text-xs' : 'text-[0.5625rem]')}>
      {abbr}
    </span>
  );
};
